var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40588"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40575"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47282",
    d: "M-707.751 288.451a1.325 1.325 0 0 1-1.328.694c-2.311-.026-4.622-.01-6.934-.01h-.244a.992.992 0 0 1-1.061-.972.977.977 0 0 1 1.053-.977c1.921-.008 3.842 0 5.762 0h.763v-30.255h-4.16v24.962c0 1.1-.284 1.38-1.391 1.38-3.5 0-7-.012-10.5.007a8.917 8.917 0 0 0-5.47 1.918 1.1 1.1 0 0 0-.519 1.1 8.086 8.086 0 0 1 .006.883h6.313a3.483 3.483 0 0 1 .439.01.979.979 0 0 1 .862.966.979.979 0 0 1-.864.965 3.839 3.839 0 0 1-.487.011h-30.859c-1.1 0-1.38-.284-1.38-1.391v-31.4c0-1.111.279-1.393 1.376-1.394h4.776v-1.736c0-.838.353-1.192 1.185-1.193 3.531 0 7.064-.009 10.6 0a10.779 10.779 0 0 1 6.745 2.32c.1.078.205.152.195.144 1.158-.614 2.217-1.246 3.334-1.749a8.719 8.719 0 0 1 3.566-.708c3.646-.015 7.292-.009 10.938-.007a1 1 0 0 1 1.136 1.143v1.785h.528c1.432 0 2.865.023 4.3-.01a1.311 1.311 0 0 1 1.328.695zm-8.14-7.131v-27.348h-.419c-3.124 0-6.247-.006-9.371 0a8.961 8.961 0 0 0-5.719 2.036.933.933 0 0 0-.383.822q.015 12.888.008 25.774v.452c.069.015.088.026.1.021a1.924 1.924 0 0 0 .171-.091 11.117 11.117 0 0 1 6.072-1.672c2.294.017 4.588 0 6.882 0zm-33.722-27.349v27.349H-739.875a10.775 10.775 0 0 1 4.186.807c.654.271 1.274.626 1.962.969v-.489q0-12.888.01-25.774a.976.976 0 0 0-.422-.853 8.942 8.942 0 0 0-5.633-2c-1.952-.013-3.9 0-5.857 0zm15.885 33.186a6.373 6.373 0 0 1 .007-.886 1.073 1.073 0 0 0-.541-1.09 8.946 8.946 0 0 0-5.522-1.905c-3.482-.012-6.964 0-10.446 0-1.077 0-1.369-.288-1.369-1.352v-24.989h-4.164v30.223z",
    style: {
      fill: "#668aed"
    },
    transform: "translate(757.751 -246.015)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47283",
    d: "M-706.771 300.839a.984.984 0 0 1-1 .975.983.983 0 0 1-.949-.972.982.982 0 0 1 1-.974.984.984 0 0 1 .949.971z",
    transform: "translate(744.755 -258.698)",
    style: {
      fill: "#668aed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47284",
    d: "M-713.038 269.92h-2.922a1 1 0 0 1-1.127-1 1 1 0 0 1 1.126-.951q2.923-.005 5.845 0a1 1 0 0 1 1.127 1 1 1 0 0 1-1.126.952c-.975.003-1.949-.001-2.923-.001z",
    transform: "translate(746.974 -250.242)",
    style: {
      fill: "#668aed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47285",
    d: "M-712.986 275.94h2.874a1 1 0 0 1 1.123.954 1 1 0 0 1-1.13 1q-2.923.005-5.846 0a1 1 0 0 1-1.122-.955c-.013-.591.435-.991 1.13-1 .99-.002 1.98.001 2.971.001z",
    transform: "translate(746.974 -252.356)",
    style: {
      fill: "#668aed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47286",
    d: "M-737.354 269.92h-2.922a1 1 0 0 1-1.127-1 1 1 0 0 1 1.126-.951q2.923-.005 5.845 0a1 1 0 0 1 1.127 1 1 1 0 0 1-1.126.952c-.975.003-1.949-.001-2.923-.001z",
    transform: "translate(753.418 -250.242)",
    style: {
      fill: "#668aed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47287",
    d: "M-737.362 277.894h-2.922a1 1 0 0 1-1.119-.958c-.011-.593.434-.991 1.133-.992q2.923-.007 5.845 0a1 1 0 0 1 1.119.958c.011.59-.438.989-1.133.993-.974.005-1.948-.001-2.923-.001z",
    transform: "translate(753.418 -252.356)",
    style: {
      fill: "#668aed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47288",
    d: "M-737.317 285.867h-2.922c-.713 0-1.155-.373-1.164-.964s.438-.986 1.138-.988q2.922-.005 5.845 0a.994.994 0 0 1 1.115.962c.008.592-.439.985-1.138.989-.957.005-1.916.001-2.874.001z",
    transform: "translate(753.418 -254.469)",
    style: {
      fill: "#668aed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3448",
    style: {
      fill: "none"
    },
    d: "M0 0h50v50H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.fbd6b90f7945e6c9727748e9a8729697.svg";
export { ForwardRef as ReactComponent };